import { TableColumn } from "react-data-table-component";
import { Fragment, useState } from "react";
import { Badges, Btn } from "../../AbstractElements";
import { RefreshCcw } from "react-feather";
import { CustomCellInterFace } from "../../Types/TablesType";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

//Modals
import UpdateDepartmentModal from "../../Components/UiKits/Modal/Department/Update";

//Services
import {
  VIEW_DEPARTMENT_QUERY_KEY,
  DEPARTMENT_QUERY_KEY,
  departmentService,
} from "../../Services/departmentService";

//Types
import { ViewDepartments } from "../../Types/CompanyProfile/Department";

const CustomBadge: React.FC<CustomCellInterFace> = ({ label, color }) => (
  <Badges pill color={color}>
    {label}
  </Badges>
);

export const StructureTableColumn: TableColumn<ViewDepartments>[] = [
  {
    name: "DIVISION",
    selector: (row) => row.division_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{`${row.division_name}`}</div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "DEPARTMENTS",
    selector: (row) => row.department_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{row.department_name}</div>
    ),
    sortable: true,
    center: false,
  },
  // {
  //   name: "STATUS",
  //   selector: (row) => row.status_label,
  //   cell: (row) => (
  //     <>
  //       <CustomBadge
  //         color={row.status_label === "ACTIVE" ? "success" : "danger"}
  //         label={row.status_label}
  //       />
  //     </>
  //   ),
  //   width: "100px",
  //   sortable: true,
  //   center: false,
  // },
  // {
  //   name: "DATE CREATED",
  //   selector: (row) => row.created_date,
  //   cell: (row) => (
  //     <div style={{ whiteSpace: "pre-line" }}>
  //       {row.created_by_user}
  //       {"\n"}
  //       {row.created_date}
  //     </div>
  //   ),
  //   width: "180px",
  //   sortable: true,
  //   center: false,
  // },
  {
    name: "DATE MODIFIED",
    selector: (row) => row.updated_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_date}
      </div>
    ),
    width: "180px",
    sortable: true,
    center: false,
  },
];
